<template>
  <div style="line-height: 24px" v-if="imressum" class="container mb-5" v-html="getDescriptionByLang(imressum)">
  </div>

</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      imressum: null,
      currentLang: localStorage.getItem("igaplus-client-language") || 'az' // default, you can set dynamically or from i18n
    };
  },
  methods: {
    getDescriptionByLang(item) {
      const field = `description_${this.currentLang}`;
      return item[field] || '';
    }
  },
  async mounted() {
    if (this.currentLang !== 'de') {
      this.$router.push('/'); // Redirect to home
      return; // Stop further execution
    }
    try {
      const response = await axios.get('/impressum'); // Adjust API URL if needed
      const data = response.data;
      if (data.length > 0) {
        this.imressum = data[0];
      }
    } catch (error) {
      console.error('Failed to fetch impressum info:', error);
    }
  }
};
</script>
